import { FC } from "react";

import {
  BooleanVoidFunc,
  ChangeSelectHandler,
} from "../../../helpers/functions/types";
import { SelectAtom } from "./atoms/SelectAtom";
import {
  CommonInputControlsProps,
  SelectOptionsProps,
  StyleVariant,
} from "./types";
import { NAMED_WRAPPER_STYLES } from "./constants";
import { LabelAtom } from "./atoms/LabelAtom";

type NamedSelectProps = CommonInputControlsProps<
  string,
  ChangeSelectHandler
> & {
  options: SelectOptionsProps;
  setShowList?: BooleanVoidFunc;
  isColor?: boolean;
};

const NAMED_SELECT_WRAPPER_STYLES: Record<StyleVariant, string | undefined> = {
  newPage: `${NAMED_WRAPPER_STYLES} flex-wrap gap-5 px-4 text-sm py-4`,
  detailPage: "",
  slideOver: `${NAMED_WRAPPER_STYLES} min-h-fit w-full flex-wrap gap-5 text-sm px-4`,
  srLabel: "",
};

export const NamedSelect: FC<React.PropsWithChildren<NamedSelectProps>> = ({
  title,
  value,
  onChange,
  setShowList,
  isColor = false,
  options,
  disabled = false,
  permissions,
  customId,
  required,
  capitalize = true,
  styleVariant = "slideOver",
}) => {
  const itemId = customId ?? title;

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className={NAMED_SELECT_WRAPPER_STYLES[styleVariant]}
    >
      <LabelAtom
        title={title}
        htmlFor={itemId}
        srOnly={styleVariant === "srLabel" || styleVariant === "detailPage"}
        capitalize={capitalize}
      />

      <SelectAtom
        name={itemId}
        options={options}
        onChange={onChange}
        setShowAutosuggestions={setShowList}
        disabled={disabled}
        required={required}
        value={value}
        permissions={permissions}
        capitalize={capitalize}
        isColor={isColor}
        styleVariant={styleVariant}
      />
    </div>
  );
};
